<template>
  <div class="retrieve-home">
    <div class="main-content">
      <result-size
        :resultNum="resultNum"
        :pageNum="resultPageNum"
        :curPage="resultCurrentPage"
        :matchNum="matchNum"
        ref="resultSize"
        @changeCurPage="handleChangeCurPage"
        @changePageSize="handleChangePageSize"
      ></result-size>
      <sort-pattern
        :detailIcon="detailIcon"
        :listIcon="listIcon"
        :modelType="modelType"
        @choosemodel="choosemodel"
        @changeStatus="handleChangeStatus"
        @changeCheckedFliter="handleChangeCheckedFliter"
      ></sort-pattern>
      <search-result-detail
        v-if="model === 'detail'"
        ref="resultDetail"
      ></search-result-detail>
      <search-result-list
        v-else-if="model === 'list'"
        ref="resultList"
      ></search-result-list>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import RetrieveSearchBar from '@/components/RetrieveSearchBar.vue'
import RetrieveLeftMenu from '@/components/RetrieveLeftMenu.vue'
import BookCarouselContent from '../../components/BookCarouselContent.vue'
import SearchResultDetail from '../../components/SearchResultDetail.vue'
import SearchResultList from '../../components/SearchResultList.vue'
import ResultSize from '../../components/ResultSize.vue'
import SortPattern from '../../components/SortPattern .vue'
import PageBar from '../../components/PageBar.vue'
export default {
  name: 'RetrieveHome',
  components: {
    RetrieveSearchBar,
    RetrieveLeftMenu,
    BookCarouselContent,
    SearchResultDetail,
    SearchResultList,
    ResultSize,
    SortPattern,
    PageBar
  },
  data () {
    return {
      modelType: 1,
      model: 'detail',
      searchText: '',
      sideBarInfo: '',
      firstSearch: true,
      resultNum: 0,
      matchNum: 0,
      resultPageNum: 0,
      resultCurrentPage: 1,
      bookId: ''
    }
  },
  computed: {
    detailIcon: {
      get () {
        if (this.modelType === 1) {
          return require('../../assets/images/icons/detail.png')
        } else {
          return require('../../assets/images/icons/detail2.png')
        }
      }
    },
    listIcon: {
      get () {
        if (this.modelType === 1) {
          return require('../../assets/images/icons/list2.png')
        } else {
          return require('../../assets/images/icons/list.png')
        }
      }
    }
  },
  mounted () {
    this.searchText = this.$route.query.searchText

    // 是否模糊匹配
    var exactSearch = Number(this.$route.query.exactSearch)

    this.$global.searchDTO.userId = localStorage.getItem('userId')
    this.$global.searchDTO.exactSearch = exactSearch
    if (this.$route.query.bookId) {
      this.bookId = this.$route.query.bookId
      this.getSearchFromBook()
      this.model = 'detail'
    } else {
      let command = this.$route.query.command
      if (this.searchText === '' || command === 'bookName') {
        this.model = 'list'
        this.modelType = this.model === 'detail' ? 1 : 0
      }
      this.getSearchInfo()

      this.$bus.$on('updateCheckedKeys', checkedKeys => {
        console.log('checkedkeys:', checkedKeys)
        this.$global.searchDTO.keyword = this.searchText
        this.$global.searchDTO.sideBarInfo = checkedKeys
        if (this.$route.query.advanced) {
          this.$global.advancedSearchDTO.sideBarInfo = checkedKeys
        }
        this.changeReturnType('bookList')
        this.getSearchInfo()
      })
    }
  },
  beforeDestroy () {
    this.$bus.$off('updateCheckedKeys')
  },
  methods: {
    choosemodel (type) {
      this.model = type
      this.modelType = type === 'detail' ? 1 : 0
      this.getSearchInfo(false)
    },
    getSearchInfo (updateMatchNum = true) {
      this.$nextTick(() => {
        this.$refs[this.model === 'detail' ? 'resultDetail' : 'resultList'].loading = true
      })
      if (this.$route.query.advanced) {
        let url = 'retrieve/search/advancedSearch'
        this.$global.advancedSearchDTO.pageSize = this.$refs.resultSize.pageSize
        this.$global.advancedSearchDTO.currentPage = this.$refs.resultSize.curPage
        if (this.$route.params.url) {
          this.$global.advancedSearchDTO.libraryStrict = localStorage.getItem('sublibrary')
        }
        this.$http.post(url, this.$global.advancedSearchDTO).then(res => {
          this.sideBarInfo = res.data.data.sideBarInfo
          this.resultNum = res.data.data.total
          this.resultPageNum = Math.ceil(
            this.resultNum / this.$refs.resultSize.pageSize
          )
          if (this.firstSearch && !this.$route.query.fromIntroduce) {
            this.$global.advancedSearchDTO.sideBarInfo = {}
            if (this.$route.params.url) {
              this.$global.advancedSearchDTO.libraryStrict = localStorage.getItem('sublibrary')
            }
            this.$global.advancedSearchDTO.currentPage = this.$refs.resultSize.curPage = 1
            if (this.$global.advancedSearchDTO.returnType !== 'bookList') {
              this.$bus.$emit('updateSideBarInfo', this.sideBarInfo)
            }
            this.firstSearch = false
          }
          for (let i in res.data.data.searchRes) {
            if (i === '0') {
              this.books = String(res.data.data.searchRes[i].id)
            } else {
              this.books =
                this.books + ',' + String(res.data.data.searchRes[i].id)
            }
          }
          if (this.$global.advancedSearchDTO.returnType === 'sidebar') { return }
          if (
            localStorage.getItem('isLogined') &&
            localStorage.getItem('isLogined') === 'true'
          ) {
            let userId = localStorage.getItem('userId')
            let url =
              'retrieve/storeBook/hasBooksInBookStore?userId=' +
              userId +
              '&bookIds=' +
              this.books
            let collects = []
            this.$http.post(url).then(res1 => {
              collects = res1.data.data
              this.$bus.$emit('updateSearchResult', {
                data1: res.data.data.searchRes,
                data2: collects
              })
            })
          } else {
            let collects = []
            for (let i = 0; i < res.data.data.searchRes.length; i++) {
              collects.push(false)
            }
            this.$bus.$emit('updateSearchResult', {
              data1: res.data.data.searchRes,
              data2: collects
            })
          }
        }).finally(() => {
          this.$refs[this.model === 'detail' ? 'resultDetail' : 'resultList'].loading = false
        })
      } else {
        this.$global.searchDTO.keyword = this.searchText
        this.$global.searchDTO.exactSearch = Number(this.$route.query.exactSearch)
        this.$global.searchDTO.type = this.$route.query.command
        if (this.$route.params.url) {
          this.$global.searchDTO.libraryStrict = localStorage.getItem('sublibrary')
        }
        let url = 'retrieve/search/search'
        this.$global.searchDTO.pageSize = this.$refs.resultSize.pageSize
        this.$global.searchDTO.currentPage = this.$refs.resultSize.curPage
        let searchDTO = this.$global.searchDTO
        this.$http.post(url, searchDTO).then(res => {
          this.sideBarInfo = res.data.data.sideBarInfo
          if (this.firstSearch && !this.$route.query.fromIntroduce) {
            this.$global.searchDTO.sideBarInfo = {}
            if (this.$global.searchDTO.keyword !== '') {
              let url = 'retrieve/searchLog/saveSearchWord'
              let params = new URLSearchParams()
              params.append('word', this.$global.searchDTO.keyword)
              this.$http.post(url, params).then(res => {
                // alert('保存成功')
              })
            }
            this.$global.searchDTO.currentPage = this.$refs.resultSize.curPage = 1
            if (this.$global.searchDTO.returnType !== 'bookList') {
              this.$bus.$emit('updateSideBarInfo', this.sideBarInfo)
            }
            this.firstSearch = false
          }
          this.resultNum = res.data.data.total
          this.resultPageNum = Math.ceil(
            this.resultNum / this.$refs.resultSize.pageSize
          )
          for (let i in res.data.data.searchRes) {
            if (i === '0') {
              this.books = String(res.data.data.searchRes[i].id)
            } else {
              this.books =
                this.books + ',' + String(res.data.data.searchRes[i].id)
            }
          }
          if (this.$global.searchDTO.returnType === 'sidebar') { return }
          if (
            localStorage.getItem('isLogined') &&
            localStorage.getItem('isLogined') === 'true'
          ) {
            let collects
            let userId = localStorage.getItem('userId')
            let url =
              'retrieve/storeBook/hasBooksInBookStore?userId=' +
              userId +
              '&bookIds=' +
              this.books
            this.$http.post(url).then(res1 => {
              collects = res1.data.data
              this.$bus.$emit('updateSearchResult', {
                data1: res.data.data.searchRes,
                data2: collects
              })
            })
          } else {
            let collects = []
            for (let i = 0; i < res.data.data.searchRes.length; i++) {
              collects.push(false)
            }
            this.$bus.$emit('updateSearchResult', {
              data1: res.data.data.searchRes,
              data2: collects
            })
          }
        }).finally(() => {
          this.$refs[this.model === 'detail' ? 'resultDetail' : 'resultList'].loading = false
        })
      }
      // 获取匹配总数
      if (updateMatchNum) {
        this.matchNum = 0
        const countUrl = 'retrieve/search/getMatchedRecordsCount?advancedSearch=' + (this.$route.query.advanced ? 1 : 0)
        this.$http.post(countUrl,
          this.$route.query.advanced ? this.$global.advancedSearchDTO : this.$global.searchDTO
        ).then(res => {
          this.matchNum = res.data.data
        })
      }
    },
    getSearchFromBook () {
      this.$http({
        method: 'GET',
        url:
          'retrieve/search/searchInBook?bookId=' +
          this.bookId +
          '&keyword=' +
          this.searchText +
          '&type=' +
          this.$route.query.command
      }).then(res => {
        this.sideBarInfo = res.data.data.sideBarInfo
        if (this.firstSearch && !this.$route.query.fromIntroduce) {
          this.$global.searchDTO.sideBarInfo = {}
          if (this.searchText !== '') {
            let url = 'retrieve/searchLog/saveSearchWord'
            let params = new URLSearchParams()
            params.append('word', this.searchText)
            this.$http.post(url, params).then(res => {
              // alert('保存成功')
            })
          }
          this.$global.searchDTO.currentPage = this.$refs.resultSize.curPage = 1
          this.$bus.$emit('updateSideBarInfo', this.sideBarInfo)
          this.firstSearch = false
        }
        this.resultNum = res.data.data.total
        this.resultPageNum = Math.ceil(
          this.resultNum / this.$refs.resultSize.pageSize
        )
        this.books = this.bookId
        if (
          localStorage.getItem('isLogined') &&
          localStorage.getItem('isLogined') === 'true'
        ) {
          let userId = localStorage.getItem('userId')
          let url =
            'retrieve/storeBook/hasBooksInBookStore?userId=' +
            userId +
            '&bookIds=' +
            this.books
          let collects = []
          this.$http.post(url).then(res1 => {
            collects = res1.data.data
            this.$bus.$emit('updateSearchResult', {
              data1: res.data.data.searchRes,
              data2: collects
            })
          })
        } else {
          let collects = []
          for (let i = 0; i < res.data.data.searchRes.length; i++) {
            collects.push(false)
          }
          this.$bus.$emit('updateSearchResult', {
            data1: res.data.data.searchRes,
            data2: collects
          })
        }
      })
    },
    handleChangeStatus (status) {
      console.log(status)
      if (status.lable === '成书年') {
        this.$global.searchDTO.sortingMethod = 'completionTime'
        this.$global.searchDTO.reverseOrder = status.status ^ 1
        this.$global.advancedSearchDTO.sortingMethod = 'completionTime'
        this.$global.advancedSearchDTO.reverseOrder = status.status ^ 1
      } else if (status.lable === '著者') {
        this.$global.searchDTO.sortingMethod = 'author'
        this.$global.searchDTO.reverseOrder = status.status ^ 1
        this.$global.advancedSearchDTO.sortingMethod = 'author'
        this.$global.advancedSearchDTO.reverseOrder = status.status ^ 1
      } else if (status.lable === '书名') {
        this.$global.searchDTO.sortingMethod = 'bookName'
        this.$global.searchDTO.reverseOrder = status.status ^ 1
        this.$global.advancedSearchDTO.sortingMethod = 'bookName'
        this.$global.advancedSearchDTO.reverseOrder = status.status ^ 1
      } else if (status.lable === '分类') {
        this.$global.searchDTO.sortingMethod = 'classification'
        this.$global.searchDTO.reverseOrder = status.status ^ 1
        this.$global.advancedSearchDTO.sortingMethod = 'classification'
        this.$global.advancedSearchDTO.reverseOrder = status.status ^ 1
      } else if (status.lable === '热度') {
        this.$global.searchDTO.sortingMethod = 'popularity'
        this.$global.searchDTO.reverseOrder = status.status ^ 1
        this.$global.advancedSearchDTO.sortingMethod = 'popularity'
        this.$global.advancedSearchDTO.reverseOrder = status.status ^ 1
      } else if (status.lable === '收藏') {
        this.$global.searchDTO.sortingMethod = 'store'
        this.$global.searchDTO.reverseOrder = status.status ^ 1
        this.$global.advancedSearchDTO.sortingMethod = 'store'
        this.$global.advancedSearchDTO.reverseOrder = status.status ^ 1
      } else if (status.lable === '免费阅读') {
        this.$global.searchDTO.sortingMethod = 'free'
        this.$global.searchDTO.reverseOrder = status.status ^ 1
        this.$global.advancedSearchDTO.sortingMethod = 'free'
        this.$global.advancedSearchDTO.reverseOrder = status.status ^ 1
      }
      this.changeReturnType('bookList')
      this.getSearchInfo(false)
    },
    handleChangeCurPage (page) {
      this.$global.searchDTO.currentPage = page
      this.changeReturnType('bookList')
      this.getSearchInfo(false)
    },
    handleChangePageSize (size) {
      //   alert(size)
      this.$global.searchDTO.pageSize = size
      if (this.$refs.resultSize.curPage !== 1) {
        this.$refs.resultSize.curPage = 1
      }
      this.changeReturnType('bookList')
      this.getSearchInfo(false)
    },
    handleChangeCheckedFliter (filters) {
      if (this.$route.query.advanced === 'true') {
        this.$global.advancedSearchDTO.customBook = 0
        this.$global.advancedSearchDTO.freeBook = 0
        this.$global.advancedSearchDTO.tryRead = 0
        for (let item of filters) {
          if (item === '定制') {
            this.$global.advancedSearchDTO.customBook = 1
          } else if (item === '全书') {
            this.$global.advancedSearchDTO.freeBook = 1
          } else if (item === '试读') {
            this.$global.advancedSearchDTO.tryRead = 1
          }
        }
      } else {
        this.$global.searchDTO.customBook = 0
        this.$global.searchDTO.freeBook = 0
        this.$global.searchDTO.tryRead = 0
        for (let item of filters) {
          if (item === '定制') {
            this.$global.searchDTO.customBook = 1
          } else if (item === '全书') {
            this.$global.searchDTO.freeBook = 1
          } else if (item === '试读') {
            this.$global.searchDTO.tryRead = 1
          }
        }
      }
      this.changeReturnType('bookList')
      this.getSearchInfo()
    },
    changeReturnType (type) {
      this.$global.searchDTO.returnType = type
      this.$global.advancedSearchDTO.returnType = type
    }
  },
  watch: {
    '$route.query' (newVal, oldVal) {
      this.searchText = newVal.searchText
      this.firstSearch = true
      let command = this.$route.query.command
      if (this.searchText === '' || command === 'bookName') {
        this.model = 'list'
      } else {
        this.model = 'detail'
      }
      this.modelType = this.model === 'detail' ? 1 : 0
      this.changeReturnType('all')
      this.getSearchInfo()
    }
  }
}
</script>
<style scoped>
.retrieve-home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.search-bar {
  position: relative;
  margin: 0 auto;
  margin-top: -50px;
  width: 1200px;
  background-color: rgba(158, 92, 29, 0.05);
  border-radius: 0px 0px 0px 0px;
}

.content {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}

.side-bar {
  width: 220px;
  height: 724px;
  background-color: #fff;
  margin: 0;
  margin-right: 18px;
}

.main-content {
  margin: 0;
  /* width: 960px; */
  /* height: 724px; */
  background-color: #fff;
  overflow: hidden;
  /* padding-left: 20px;
  padding-top: 10px;
  padding-right: 20px;
  padding-bottom: 40px; */
}

.icon-title {
  display: flex;
  align-items: center;
  justify-content: left;
  border-bottom: 1px solid #9e5c1d;
  width: 156px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
}

.icon {
  width: 34px;
  margin-right: 10px;
}

.recommand-book {
  width: 880px;
  margin: 0 auto;
}

.recommand-book >>> .book-cards {
  width: 120px;
}

.recommand-book >>> .arrow {
  width: 37px;
  height: 37px;
}

.recommand-book >>> .book-title {
  margin-top: 0;
  margin-bottom: 7px;
  font-size: 16px;
  color: #634c37;
}

.introduction-text {
  width: 845px;
  margin: 0 auto;
  line-height: 36px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 16px;
  color: #634c37;
  text-align: left;
}

.introduction-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.introduction-list li {
  margin: 0;
  padding: 0;
  margin-bottom: 10px;
  font-size: 16px;
  color: #634c37;
  text-align: left;
}

.introduction-list li::before {
  content: " ";
  width: 8px;
  height: 8px;
  display: inline-block;
  background-color: #9e5c1d;
  transform: rotate(45deg);
  margin-right: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/retrieve/RetrieveResult.vue